{
  "customFormsFeaturesData": {
    "titles": {
      "checkOut": "เช็กเอาต์",
      "checkInDeprecated": "เช็กอิน (เลิกใช้แล้ว)",
      "checkIn": "เช็กอิน",
      "receivedLoadInspection": "การตรวจสอบสินค้าที่รับเข้า",
      "shippedLoadVerification": "การยืนยันสินค้าที่จัดส่ง",
      "appointmentsPerLoadType": "การนัดหมายตามประเภทสินค้า",
      "assetDetails": "รายละเอียดอุปกรณ์",
      "yardManagementSystem": "ระบบจัดการลานจอด",
      "smartGateIntegration": "การเชื่อมต่อ SmartGate",
      "gateManagement": "การจัดการประตูทางเข้า",
      "idValidation": "การยืนยันตัวตน",
      "appointmentCompleted": "การนัดหมายเสร็จสิ้น"
    },
    "subtitles": {
      "phoneNumberAndCarrierCompanyWillBeCollectedByDefault": "ระบบจะเก็บ<strong>หมายเลขโทรศัพท์</strong>และ<strong>บริษัทขนส่ง</strong>โดยค่าเริ่มต้น"
    },
    "descriptions": {
      "captureCheckInDetailsFromDriversForBothPlannedAndUnplannedArrivals": "เก็บรายละเอียดการเช็กอินจากคนขับ ทั้งการมาถึงที่มีการวางแผนและไม่ได้วางแผน",
      "captureCheckOutDataAfterAnAppointmentIsCompleted": "เก็บข้อมูลการเช็กเอาต์หลังจากการนัดหมายเสร็จสิ้น",
      "collectDriverInfoAsTheySelfCheckInForTheirPlannedAppointmentThisFeatureIsAnOptionalAddOnToOurGateManagementSolution": "เก็บข้อมูลคนขับเมื่อเช็กอินด้วยตนเองสำหรับการนัดหมายที่วางแผนไว้ ฟีเจอร์นี้เป็นส่วนเสริมที่เลือกใช้ได้ของโซลูชันการจัดการประตูทางเข้าของเรา",
      "documentDamageDiscrepanciesOrOtherIssuesRelatedToTheReceivedLoad": "บันทึกความเสียหาย ความคลาดเคลื่อน หรือปัญหาอื่น ๆ ที่เกี่ยวข้องกับสินค้าที่รับเข้า",
      "documentLoadIntegrityAndOtherSecurityMeasuresRelatedToTheShippedLoad": "บันทึกความสมบูรณ์ของสินค้าและมาตรการรักษาความปลอดภัยอื่น ๆ ที่เกี่ยวข้องกับสินค้าที่จัดส่ง",
      "captureLoadTypeSpecificDetailsDuringAppointmentScheduling": "เก็บรายละเอียดเฉพาะของประเภทสินค้าระหว่างการนัดหมาย",
      "storeAndTrackDetailsOfTrailersAndContainersAsTheyArriveAtYourYard": "จัดเก็บและติดตามรายละเอียดของรถพ่วงและตู้คอนเทนเนอร์เมื่อมาถึงลานจอดของคุณ",
      "enableTheYmsModuleForThisWarehouseAlsoEnableTheAssetVisitFieldsForTheGateManagementApp": "เปิดใช้งานโมดูล YMS สำหรับคลังสินค้านี้ และเปิดใช้งานช่องข้อมูลการเข้าพื้นที่ของอุปกรณ์สำหรับแอปการจัดการประตูทางเข้า",
      "enableTheSmartGateModuleForThisWarehouse": "เปิดใช้งานโมดูล SmartGate สำหรับคลังสินค้านี้",
      "enableTheIdValidationForThisWarehouse": "เปิดใช้งานโมดูลการยืนยันตัวตนสำหรับคลังสินค้านี้",
      "enableTheGateManagementModuleForThisWarehouseWhichIncludesTheCheckIn": "เปิดใช้งานโมดูลการจัดการประตูทางเข้าสำหรับคลังสินค้านี้ ซึ่งรวมถึงการเช็กอิน",
      "reviewAndManageAppointmentDataAfterCompletion": "ตรวจสอบและจัดการข้อมูลการนัดหมายหลังจากเสร็จสิ้น"
    },
    "helpLinks": {
      "learnHowItWorksOrContactUsToRequestATrial": "<a href=\"https://community.loadsmart.com/hc/en-us/articles/19326940613011-Carrier-Self-Check-In\" target=\"_blank\">เรียนรู้วิธีการทำงาน</a> หรือติดต่อเราเพื่อ<a href=\"https://lp.opendock.com/gate-management\" target=\"_blank\">ขอทดลองใช้งาน</a>",
      "learnHowItWorks": "<a href=\"https://community.loadsmart.com/hc/en-us/articles/19326940613011-Carrier-Self-Check-In\" target=\"_blank\">เรียนรู้วิธีการทำงาน</a>"
    },
    "enableDisclaimers": {
      "theDriversWillSeeThisFormWhenTheyAreCheckingThemselvesIn": "คนขับจะเห็นแบบฟอร์มนี้เมื่อเช็กอินด้วยตนเอง",
      "allFieldsOnThisFormWillBeAvailableAndVisibleDuringAppointmentScheduling": "ทุกช่องข้อมูลในแบบฟอร์มนี้จะ<strong>พร้อมใช้งานและแสดงให้เห็น</strong>ระหว่างการนัดหมาย"
    },
    "disableDisclaimers": {
      "theDriversWillNotSeeThisFormWhenTheyAreCheckingThemselvesIn": "คนขับจะไม่เห็นแบบฟอร์มนี้เมื่อเช็กอินด้วยตนเอง",
      "allFieldsOnThisFormWillBeUnavailableDuringAppointmentSchedulingYouCanReEnableThisFormAtAnyTime": "ทุกช่องข้อมูลในแบบฟอร์มนี้จะ<strong>ไม่พร้อมใช้งาน</strong>ระหว่างการนัดหมาย<br />คุณสามารถเปิดใช้งานแบบฟอร์มนี้อีกครั้งได้ทุกเมื่อ"
    },
    "labels": {
      "updateClaimsSupport": "อัปเดตข้อมูลประกอบการเคลม",
      "selectAClaimsSupportToUpdate": "เลือกข้อมูลประกอบการเคลมที่จะอัปเดต",
      "damageType": "ประเภทความเสียหาย",
      "damageDescription": "คำอธิบายความเสียหาย",
      "damagePhotos": "รูปถ่ายความเสียหาย",
      "discrepancyType": "ประเภทความคลาดเคลื่อน",
      "discrepancyDescription": "คำอธิบายความคลาดเคลื่อน",
      "discrepancyPhotos": "รูปถ่ายความคลาดเคลื่อน",
      "loadSecurityChecked": "ตรวจสอบความปลอดภัยของสินค้าแล้ว",
      "loadSecurityDescription": "คำอธิบายความปลอดภัยของสินค้า",
      "loadIntegrityPhotos": "รูปถ่ายความสมบูรณ์ของสินค้า",
      "sealIntegrityPhotos": "รูปถ่ายความสมบูรณ์ของซีล"
    }
  }
}
